import { render, staticRenderFns } from "./forget-pwd-verify.vue?vue&type=template&id=bd1e5ba0&scoped=true"
import script from "./forget-pwd-verify.vue?vue&type=script&lang=js"
export * from "./forget-pwd-verify.vue?vue&type=script&lang=js"
import style0 from "./forget-pwd-verify.vue?vue&type=style&index=0&id=bd1e5ba0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1e5ba0",
  null
  
)

export default component.exports